import { render, staticRenderFns } from "./Reminders.vue?vue&type=template&id=d50841fe"
import script from "./Reminders.vue?vue&type=script&lang=ts"
export * from "./Reminders.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d50841fe')) {
      api.createRecord('d50841fe', component.options)
    } else {
      api.reload('d50841fe', component.options)
    }
    module.hot.accept("./Reminders.vue?vue&type=template&id=d50841fe", function () {
      api.rerender('d50841fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/default/Reminders.vue"
export default component.exports